import { Cube } from "./types";

/**
 * Alleen `type` en `coordinates` uit de cube-geometrie.
 *
 * De cube draagt daar ook `properties` (area, perimeter) in mee, en dat hoort
 * niet in een GeoJSON-geometrie die de backend als PolygonField opslaat of aan
 * de omgevingsmonitor doorgeeft. Spiegelt `_geometry_only` in
 * `ca_project/workspace/parcel_create.py`.
 */
export const cubeGeometry = (cube: Cube): GeoJSON.Geometry => {
  const { type, coordinates } = cube.geometry as unknown as {
    type: string;
    coordinates: number[][][];
  };
  return { type, coordinates } as GeoJSON.Geometry;
};
